export const CRF_VERSION_MANAGEMENT_ROUTE_NAME = 'CrfVersionManagement'
export const CRF_VERSION_MANAGEMENT_ROUTE_PATH = 'crf-versions'

export const CRF_VERSION_DETAIL_ROUTE_NAME = 'CrfVersionDetail'
export const CRF_VERSION_DETAIL_ROUTE_PATH = 'crf-versions/:versionId'

export function buildCrfVersionDetailRouteLocation(versionId: string) {
  return {
    name: CRF_VERSION_DETAIL_ROUTE_NAME,
    params: {
      versionId,
    },
  } as const
}
